export const TEST_ID = 'batteryNameField';
